import {
    useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import {
    Postponement,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import requests from 'app/requests/Order/Order.requests'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'

import columns from './OrderPostponements.columns'
import useStyles from './OrderPostponements.style'

const OrderPostponements = ({
    orderNumber,
}: {
    orderNumber: string,
}) => {
    const {
        classes,
    } = useStyles()

    const urlConfig = useMemo(() => {
        const url = requests.getPostponement({
            orderNumber,
        })

        return {
            customUrl: url.url,
            method: url.method,
            name: 'PostponementView',
        }
    }, [orderNumber])

    const load: (params: any) => Promise<{
        items: Postponement[],
        matches: number,
    }> = useLoadDtoForSkyNetTable(
        urlConfig,
    )

    return (
        <RichTable
            configName="OrderPostponementsTable"
            name="PostponementView"
            columns={columns}
            load={load}
            className={classes.tableContent}
            classNames={{
                contentWrapper: classes.tableContentWrapper,
            }}
            rowStyle={{
                crossLine: 'isRejected',
            }}
        />
    )
}

export default OrderPostponements
